import { render, staticRenderFns } from "./AffinityOffersListRoute.vue?vue&type=template&id=5f8665aa&scoped=true&"
import script from "./AffinityOffersListRoute.vue?vue&type=script&lang=js&"
export * from "./AffinityOffersListRoute.vue?vue&type=script&lang=js&"
import style0 from "./AffinityOffersListRoute.vue?vue&type=style&index=0&id=5f8665aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8665aa",
  null
  
)

export default component.exports